import NavigationBreadcrumbs from './NavigationBreadcrumbs';

export default NavigationBreadcrumbs;
